import { UserQuestionResponse } from 'src/types/survey';
import api from './axiosConfig';

export const getRegistrationQuestions = async (): Promise<any> => {
  try {
    const response = await api({
      method: 'get',
      url: `v2/psp/registration/questions`,
    });
    return {
      questions: response.data,
      error: false,
    };
  } catch (error) {
    console.error(error);
    return {
      questions: [],
      error: true,
    };
  }
};

export const getCart = async (surveyAnswers: UserQuestionResponse[]) => {
  try {
    const response = await api({
      method: 'post',
      url: `/v2/psp/registration/cart`,
      data: surveyAnswers,
    });
    return {
      data: response.data,
      error: false,
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};

export const submitCoupon = async (promoCode: string) => {
  try {
    const response = await api({
      method: 'post',
      url: `/v2/psp/coupon/validate`,
      data: {
        promoCode: promoCode,
      },
    });
    return {
      data: response.data,
      error: false,
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};

export const getTaxRate = async (country: string, state: string) => {
  try {
    const response = await api({
      method: 'get',
      url: `/v2/psp/taxRate`,
      params: {
        country: country,
        state: state,
      },
    });
    return {
      data: response.data,
      error: false,
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
    };
  }
};
